



































































import { Component, Prop, Watch } from "vue-property-decorator"
import { filter, find } from "lodash"
import Super from "@/pv4-super-class"
@Component({})
export default class DataTagSelector extends Super {
  @Prop({ required: true, type: Number }) eventId: any
  @Prop({ required: false, default: "" }) value: any
  @Prop({ required: false, type: String, default: "is-bottom-left" })
  position: any

  dataTriggers: any = [
    {
      dataTriggerID: 1,
      dataTriggerCode: "before-cue-load",
      dataTriggerName: "Post Store Hook",
      dataTriggerDescription:
        "Runs after Data-Store is loaded- use to transform raw data into nicer objects."
    }
  ]

  @Watch("value", { immediate: true })
  processDataTags() {
    if (!this.value) return
    let triggers = this.value.split(",")
    if (!triggers) return
    triggers.forEach(t => {
      let matchingTrigger = find(this.dataTriggers, { dataTriggerCode: t })
      if (matchingTrigger) matchingTrigger.selected = true
    })
  }

  async mounted() {
    await this.load()
    this.processDataTags()
  }

  get formattedDataTriggers() {
    return this.value
  }

  get selectedDataTriggers() {
    let selected = filter(this.dataTriggers, { selected: true })
    if (!selected) return []
    return selected.map(s => s.dataTriggerCode)
  }

  change() {
    this.$emit("input", this.selectedDataTriggers.join(","))
    this.$emit("change", this.selectedDataTriggers)
  }

  load() {
    /*  let loadDataTags = this.$http.get(`/data-tags?eventID=${this.eventId}`)
        .then(res => {
          if (res.data.status != "success") throw(res.data.message)
          this.dataTags = res.data.data.map(t => ({selected: false, ...t}));
        })

    Promise.all([loadDataTags]).catch(this.displayError)*/
  }
}
